// i18n area 'networks' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua): tradotto DALL'ITALIANO (lingua SORGENTE, regola 2026-08-03).
// Glossario di sezione: undirnet (subnet), gátt (gateway), leið (rotta), eldveggur
// (firewall), skiptir (switch), tengi (interfaccia), hlustari (listener), biðlari
// (client), púki (demone), færsla (record), svæði (zona DNS), göng (tunnel),
// dreifilykill (chiave pubblica), endurvarp (relay), samskiptaregla (protocollo);
// restano invariati fabric, overlay/underlay, pool, peer, VLAN/LACP/LAGG/MLAG,
// NAT/DNAT/SNAT/masquerade, next hop, reverse proxy, passthrough, wildcard,
// keepalive, handshake. Sidecar anti-stantie: ../meta/networks.is-IS.meta.json.
import type { enUS } from './networks'

export const isIS: typeof enUS = {
  networks: {
    common: {
      name: 'Nafn',
      scope: 'Scope',
      operState: 'Staða',
      actions: 'Aðgerðir',
      create: 'Búa til',
      close: 'Loka',
      cancel: 'Hætta við',
      delete: 'Eyða',
      edit: 'Breyta',
      save: 'Vista',
      editError: 'Breyting mistókst',
      search: 'Leita eftir nafni',
      empty: 'Enn ekkert hér',
      saveError: 'Ekki tókst að vista',
      loadError: 'Ekki tókst að sækja — næst samband við TVirt-bakendann?',
      createError: 'Stofnun mistókst',
      deleteError: 'Eyðing mistókst',
      deleteConfirmTitle: 'Eyða {name}?',
      deleteConfirmBody: 'Aðgerðin er óafturkræf.',
      nameHint: 'Lágstafir, tölustafir og bandstrik (DNS-1123)',
      up: 'Virk',
      down: 'Óvirk',
      unknown: 'Óþekkt',
      usedByVMs: 'VM',
      emptyTable: 'Engar færslur — bættu einni við með + hnappnum'
    },
    dialogTabs: {
      general: 'Almennt',
      base: 'Grunnskilgreining',
      advanced: 'Ítarlegar stillingar',
      reserved: 'Bil frátekin fyrir TVirt',
      position: 'Staðsetning',
      network: 'Netstillingar',
      hosts: 'Þátttökuhnútar'
    },
    reservedRanges: {
      note: 'Þetta eru IP-bil frátekin fyrir TVirt sem það getur notað til að úthluta VM, gámum o.s.frv. vistfangi sjálfvirkt. ATH: IP-tölur í þessum bilum mega ekki vera notaðar utan TVirt af ytri þjónustum eða búnaði.',
      from: 'Frá',
      to: 'Til'
    },
    overlay: {
      title: 'Overlay-net',
      createTitle: 'Búa til overlay-net',
      editTitle: 'Breyta overlay-neti',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — úthlutað sjálfvirkt ef autt',
      subnet: 'Undirnet',
      subnetHint: 'CIDR overlay-netsins — IPAM leiðir færslu sína sjálfkrafa af því',
      mtu: 'MTU',
      weight: 'Vægi',
      ceilMbps: 'Þak (Mbps)',
      fairnessHint: 'Vægið gildir aðeins við álag: á lausum tengli má hvert net nota alla bandbreiddina. Þakið gildir hins vegar alltaf.',
      contention: 'Keppni',
      contentionTip: 'Að minnsta kosti einn hnútur sér tap eða overlimit MEÐ biðröð á flokki þessa nets: keppt er um bandbreidd uplinksins og vægin virka. Hve mikið og síðan hvenær er í net.shaping.*-röðum hnútsins.',
      firewallPolicy: 'Eldveggsstefna',
      hosts: 'Hýslar',
      hostsTitle: 'Þátttökuhnútar',
      hostsHint: 'Hver hnútur gefur upp underlay-endapunkt sinn — fellilisti yfir RAUNVERULEG vistföng hnútsins, lesin úr netstillingum hans; valfrjálsa overlay-vistfangið verður að vera innan undirnetsins. Þátttakan er staðsetningarskorðan.',
      hostNode: 'Hnútur',
      hostUnderlay: 'Underlay-IP',
      hostUnderlayPickNode: 'Veldu fyrst hnútinn',
      hostAddress: 'Vistfang á overlay-netinu (valfrjálst)',
      hostAddressOutside: 'Utan undirnets yfirlagsnetsins ({cidr})',
      addHost: 'Bæta við hnút',

      // Round #156 (dialog standard): le righe osservate del dialog dettagli.
      observedAt: 'Athugað þann',
      attachedNics: 'Tengd NIC'
    },
    services: {
      title: 'Netþjónustur',
      createTitle: 'Búa til netþjónustu',
      editTitle: 'Breyta netþjónustu',
      kind: 'Tegund',
      kindCategory: 'Þjónustur',
      selectKindHint: 'Veldu tegund þjónustunnar — undirliggjandi púkinn er útfærsluatriði sem TVirt sér um fyrir þig.',
      kindLabel: {
        dhcp: 'DHCP-þjónn',
        ntp: 'NTP-þjónn',
        vpn: 'VPN-þjónn',
        dns: 'DNS-þjónn',
        gateway: 'Gátt',
        'lb-rp': 'Álagsjafnari og reverse proxy',
        floatip: 'Fljótandi IP'
      },
      kindDesc: {
        dhcp: 'Úthlutar vistföngum á þjónuðu undirnetunum — pool-in eru leidd af undirneti, gátt og fráteknum TVirt-bilum netsins.',
        dns: 'Authoritative DNS á yfirlýstum svæðum — færslurnar eru leiddar af IPAM auk handvirkra færslna þinna.',
        gateway: 'Hnúturinn þjónar sem gátt fyrir net — NAT (DNAT, 1:1, SNAT/masquerade) auk fastra leiða milli tengdu netanna, sjálfviðgerandi samkvæmt hönnun.',
        'lb-rp': 'Álagsjafnari / öfugt proxy fyrir framan þjónustur þínar — L4 eða L7 hlustarar yfir hópum meðlima eða yfir tilbúnum tilvikum Pods, endurstilltir á flugi.',
        ntp: 'Tímaþjónusta netanna — endurvarp ytri upstream-þjóna, eða klukka hnútsins borin fram til biðlaranna.',
        vpn: 'VPN-miðstöð á hnútnum — WireGuard eða OpenVPN, þú velur: fjaraðgangur fyrir biðlara á faraldsfæti, eða site to site-göng milli tveggja neta.',
        floatip: 'Eitt vistfang sem situr aðeins á einu heilbrigðu App-tilviki eða Pod í einu og færist á næsta heilbrigða skotmark þegar það fellur — failover án púka; jöfnunin er áfram hjá álagsjafnaranum.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Fljótandi IP lifir á völdu neti sem AUKAvistfang inni í nafnrými tilviksins sem heldur því: engin port, engin jöfnun, ekkert NAT — IP biðlarans helst raunverulegt.',
        address: 'Fljótandi IP',
        targets: 'Skotmörk',
        targetsHint: 'Í FORGANGSröð: fyrsta heilbrigða skotmarkið heldur vistfanginu. Pod stendur fyrir öll tilvik sín, eftir eftirmynd; hvert skotmark hefur sitt eigið heilbrigðisviðmið. Hvert skotmark verður að vera tengt sama neti.',
        targetKind: 'Skotmark',
        targetApp: 'App-tilvik',
        targetPod: 'Pod (öll tilvik)',
        targetRef: 'Hvert',
        health: 'Heilbrigði',
        healthRunning: 'Í gangi (hver gámur tilbúinn)',
        healthTcp: 'TCP-tenging',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Slóð',
        addTarget: 'Bæta við skotmarki',
        moveUp: 'Færa upp',
        moveDown: 'Færa niður',
        preempt: 'Preempt',
        preemptHint: 'Slökkt (sjálfgefið): heilbrigður handhafi heldur vistfanginu jafnvel þótt hærra skotmark komi aftur — ekkert flökt. Kveikt: fyrsta heilbrigða skotmarkið heldur því alltaf.',
        holder: 'Handhafi',
        noHolder: 'ekkert heilbrigt skotmark',
        since: 'síðan',
        verdicts: 'Athuguð skotmörk',
        healthy: 'heilbrigt',
        unhealthy: 'óheilbrigt',
        noVerdict: 'Ekki enn ákveðið — heimildarhnúturinn skrifar fyrsta úrskurðinn í næstu umferð sinni.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Þetta tilvik heldur fljótandi IP {address} þjónustunnar {service}'
      },
      poolSource: 'Endapunktar',
      poolSourceMembers: 'Fastir meðlimir',
      poolSourcePod: 'Tilbúin tilvik Pods',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Endapunktarnir fylgja Pod: tilvik kemur inn þegar það er í gangi með hvern gám tilbúinn og fer strax út þegar það er minnkað eða deyr. Virka athugunin er sjálfgefið kveikt.',
      poolBackendCount: 'tilbúin tilvik Pods {pod} á porti {port}',
      node: 'Hnútur',
      enabled: 'Virkjað',
      parked: 'Í stæði',
      subnets: 'Undirnet',
      subnetsHint: 'IPAM-undirnetin sem þessi þjónusta þjónar — pool-in eru leidd af CIDR, gátt og fráteknum TVirt-bilum',
      noSubnets: 'Ekkert IPAM-undirnet — lýstu fyrst yfir röklegu fabric-neti (eða overlay-undirneti): IPAM leiðist af þeim',
      iface: 'Hlustunartengi',
      ifaceHint: 'Hýsiltengið sem þjónustan opnar socket sinn á (t.d. brú) — skylda: netþjónusta er sjálfstæð, „öll tengi“ er ekki lengur til',
      dns: 'DNS-þjónar',
      domain: 'Lén',
      detail: 'Þjónar',
      subnetCount: '{n} undirnet',
      zones: 'Svæði',
      zonesHint: 'Aðeins authoritative — púkinn leitar aldrei áfram. A-færslurnar eru leiddar af yfirlýstum vistföngum hnútanna í tilvísuðu IPAM-undirnetunum; reverse-rofinn þjónar líka samsvarandi in-addr.arpa-svæðum (PTR). Svæði er þjónað af í mesta lagi einni DNS-þjónustu í flotanum. Valfrjálsi nafnaþjónninn er FQDN sem er skrifað í NS/SOA-færslurnar í stað sjálfgefna ns.<svæði>; falli hann innan svæðisins er A-færsla hans samt leidd af þjónandi hnútnum.',
      zoneName: 'Nafn svæðis',
      zoneNs: 'Nafnaþjónn (NS)',
      zoneSubnets: 'IPAM-undirnet',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Handvirkar færslur',
      zoneRecordsHint: 'Ein í hverri línu: nafn TEGUND gildi — tegundir A, CNAME, MX, TXT. Rekist nöfn á vinnur handvirka færslan á þeirri leiddu.',
      addZone: 'Bæta við svæði',

      // lb-rp (wave 3 fondamenta): listener su pool inline — engine-less,
      // riconfigurato in volo.
      lbListeningHint: 'Þjónustan lýsir yfir EINU hlustunarneti og EINU vistfangi — hver hlustari bindur það á sínu porti; annað vistfang er önnur þjónusta.',
      listeners: 'Hlustarar',
      listenersHint: 'Hver hlustari bindur vistfang þjónustunnar á sínu porti í L4-ham (TCP-passthrough — bætin eru aldrei opnuð) eða L7 (HTTP) og áframsendir á eitt af pool-unum hér fyrir neðan. Vistfangs- og portapar er þjónað af í mesta lagi einni þjónustu á hnút. Breytingar taka gildi á flugi — engin endurræsing, engin tenging tapast.',
      listenerName: 'Nafn',
      listenerMode: 'Hamur',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP-passthrough',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Bæta við hlustara',
      pools: 'Pool',
      poolsHint: 'Bakendarnir sem umferðin lendir á: fastir meðlimir jafnaðir round robin eða á minnst upptekinn, með valfrjálsri virkri heilsuathugun sem tekur veika meðlimi úr umferð.',
      poolName: 'Nafn',
      poolAlgorithm: 'Reiknirit',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Minnst upptekinn',
      poolCheck: 'Heilsuathugun',
      checkNone: 'Engin',
      checkTcp: 'TCP-tenging',
      checkHttp: 'HTTP',
      poolCheckPath: 'Könnunarslóð',
      poolInterval: 'Millibil (s)',
      poolMembers: 'Meðlimir',
      poolMembersHint: 'Einn í hverri línu: vistfang:port, valfrjálst fylgt eftir af vægi (1-128) — t.d. 10.0.0.21:8080 2',
      addPool: 'Bæta við pool',
      memberCount: '{n} meðlimir',

      // ntp (round ntp — ratifica 2026-08-03, l'ultimo kind della famiglia):
      // il modo in parole parlate, la lista upstream solo dove significa
      // qualcosa, l'attacco di rete riusa le etichette del gateway.
      // #239 (netsvc autocontenuti): l'editor condiviso della lista di
      // listener dei kind dns e ntp — le due eccezioni multi-rete ratificate.
      listen: {
        assignment: 'Úthlutun',
        assignmentStatic: 'Fast vistfang',
        assignmentAuto: 'Sjálfvirk (TVirt-frátekin svið)',
        autoHint: 'TVirt dregur vistfangið úr fráteknum sviðum rökrétta netsins og heldur því sticky — aldrei dregið aftur við breytingu eða failover.',
        title: 'Hlustarar',
        hint: 'Netþjónusta er sjálfstæð: hver hlustari lýsir yfir neti sínu (overlay, röklegt fabric-net eða tengi) og vistfangi innan undirnets síns — einn hlustari á vistfang, wildcard er ekki lengur til. DNS og NTP mega hlusta á fleiri netum og fleiri vistföngum þeirra neta.',
        address: 'Hlustunarvistfang',
        add: 'Bæta við hlustara'
      },
      ntp: {
        mode: 'Samstillingarmáti',
        modeRelay: 'Endurvarp ytri þjóna',
        modeNodeClock: 'Klukka hnútsins',
        modeHint: 'Endurvarpið ber fram tímann frá yfirlýstu upstream-þjónunum; klukka hnútsins ber fram tíma þjónandi hnútsins — sem klasinn heldur hvort eð er samstilltum',
        servers: 'Upstream-þjónar',
        serversHint: 'Aðskildir með kommu — hýsilnafn eða IP-tala; þjónustan tekur tímann þaðan og ber hann fram á netið',
        port: 'Hlustunarport',
        listening: 'Hlustar á'
      },

      vpn: {
        engine: 'Vél',
        engineHint: 'Þú velur hana, og hún breytist ekki aftur: WireGuard er nútímalegt, hratt og í kjarnanum; OpenVPN er öldungur samhæfninnar (TCP, fjandsamleg net)',
        engineLocked: 'Vélin er óbreytanleg — önnur vél er ný þjónusta, lyklar og skilríki eru ekki flytjanleg',
        mode: 'Máti',
        modeRemote: 'Fjaraðgangur',
        modeSite: 'Site to site',
        modeHint: 'Fjaraðgangur gefur biðlurum á faraldsfæti vistfang í göngunum; site to site sameinar tvö net',
        port: 'Hlustunarport',
        protocol: 'Flutningur',
        protocolWireguardHint: 'WireGuard talar aðeins UDP',
        tunnelSubnet: 'Undirnet ganganna',
        tunnelSubnetHint: 'Netið sem biðlararnir búa í — skráð í IPAM-skrána, fæðist og deyr með þessari þjónustu',
        dnsServers: 'DNS ýtt til biðlara',
        routes: 'Leiðir ýttar til biðlara',
        routesHint: 'Net aðskilin með kommu, náanleg í göngunum; undirnet ganganna er alltaf innifalið',
        peers: 'Peerar',
        peersHint: 'Skildu dreifilykilinn eftir auðan og TVirt býr til parið — afhendir það svo með prófílnum. Límdu inn lykil og peerinn heldur sínum.',
        clients: 'Biðlarar',
        clientsHint: 'Hver biðlari fær skilríki gefið út af CA þessarar þjónustu. Að fjarlægja biðlara AFTURKALLAR hann: CRL-listinn er endurgerður strax.',
        peerName: 'Nafn',
        publicKey: 'Dreifilykill',
        publicKeyMinted: 'TVirt býr hann til',
        peerAddress: 'Vistfang í göngunum',
        peerAddressHint: 'Autt = úthlutað',
        allowedIps: 'Fjarlæg undirnet',
        allowedIpsHint: 'Aðskilin með kommu, leidd í gegnum þennan peer',
        endpoint: 'Endapunktur',
        presharedKey: 'Fyrirframdeildur lykill',
        keepalive: 'Keepalive (s)',
        addPeer: 'Bæta við peer',
        addClient: 'Bæta við biðlara',
        auth: 'Auðkenning',
        authTls: 'Skilríki (TLS)',
        remote: 'Fjarlægur endapunktur',
        remoteHint: 'hýsill:port fjarlæga endans — autt þýðir að þessi hlið bíður',
        peerRoutes: 'Fjarlæg undirnet',
        serverPublicKey: 'Dreifilykill þessa þjóns',
        ca: 'Útgefandi skilríkja',
        listening: 'Hlustar á',
        tunnel: 'Göng',
        peerCount: '{n} peerar',
        download: 'Sækja prófíl',
        downloadError: 'Ekki tókst að flytja út prófílinn',
        lastHandshake: 'Síðasta handshake',
        never: 'aldrei',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Tengdur',
        idle: 'Aðgerðalaus'
      },

      // Gateway (wave 3 — nato nat, ratifica 2026-08-01/02; rinominato ed
      // esteso il 2026-08-03): le tre famiglie di regole NAT più le rotte
      // statiche su una rete di listening. Ogni forma ratificata è supportata.
      gateway: {
        attach: 'Tegund hlustunarnets',
        attachOverlay: 'Overlay-net',
        attachNetwork: 'Röklegt fabric-net',
        attachInterface: 'Hrátt tengi',
        overlay: 'Overlay-net',
        network: 'Röklegt net',
        interface: 'Nafn tengis',
        interfaceHint: 'Hýsiltengi sem TVirt stjórnar ekki — vistfangið er tekið gott og gilt',
        address: 'Hlustunarvistfang (gátt)',
        addressHint: 'Gáttarvistfangið sem biðlararnir vísa á — innan undirnets hlustunarnetsins',
        dnatTitle: 'DNAT-reglur',
        dnatHint: 'NAT á áfangastað: umferð sem passar er endurbeint á nýtt vistfang (og valfrjálst nýtt port). Hvaða samskiptaregla sem er af listanum — port þar sem samskiptareglan ber þau.',
        snatTitle: 'SNAT-reglur',
        snatHint: 'NAT á uppruna: umferð sem passar fer út með endurskrifaðan uppruna — nýtt skýrt vistfang (og valfrjálst nýtt port), eða masquerade á útgangsvistfangið sé það skilið eftir autt.',
        oneToOneTitle: '1:1 NAT-reglur',
        oneToOneHint: 'Hver pakki á ytra vistfangið varpast á það innra, og innri hýsillinn fer út sem sá ytri — allar samskiptareglur, báðar áttir.',
        external: 'Ytra vistfang',
        internal: 'Innra vistfang',
        addOneToOne: 'Bæta við 1:1 reglu',
        family: 'Fjölskylda',
        protocol: 'Samskiptaregla',
        source: 'Uppruni (vistfang/undirnet)',
        destination: 'Áfangastaður (vistfang/undirnet)',
        invert: 'NOT',
        srcPorts: 'Upprunaport',
        dstPorts: 'Áfangaport',
        dstPortsHint: 'Port eða bil (80, 8000-8099)',
        toAddress: 'Nýtt vistfang',
        toPort: 'Nýtt port',
        snatTo: 'Nýr uppruni (autt = masquerade)',
        snatToHint: 'Skýrt upprunavistfang; autt = masquerade á útgangsvistfangið',
        addDnat: 'Bæta við DNAT-reglu',
        addSnat: 'Bæta við SNAT-reglu',
        routesTitle: 'Fastar leiðir',
        routesHint: 'Hnúturinn beinir umferð milli netanna sem hann er tengdur við (IP forwarding er virkt); þessar leiðir bæta við náanleika umfram þau — hreinn kjarni, kvikt routing kemur í síðara round.',
        routeDestination: 'Áfangaundirnet',
        routeGateway: 'Next hop',
        routeMetric: 'Metrík',
        addRoute: 'Bæta við leið',
        listening: 'Hlustar á',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} leiðir'
      },
      unknownSince: 'Óþekkt — síðasta skýrsla fyrir {m} mín.',
      lastWord: 'Síðasta orðið',

      // Round #156 (dialog standard): le righe osservate e il riepilogo in
      // sola lettura del blocco kind nel dialog dettagli.
      reportObservedAt: 'Síðasta skýrsla',
      lastErrorRow: 'Síðasta villa',
      recordsCount: '{n} handvirkar færslur',
      phase: {
        configured: 'Stillt',
        running: 'Í keyrslu',
        error: 'Villa'
      },
      authorityNode: 'Authority (úthlutun)',
      preferredNode: 'Kjörhnútur',
      preferredNodeHint: 'Mjúk ósk, aldrei skilyrði: við næstu staðsetningarákvörðun lendir þjónustan hér ef meðlimurinn er gjaldgengur — ein og sér hreyfir hún ekkert; leikurinn er „Færa authority“.',
      noPreference: 'Engin ósk (sjálfvirk staðsetning)',
      moving: 'Á hreyfingu',
      movingTooltip: 'Sést hér á meðan authority úthlutar {node}: leikurinn er að ganga í gegn.',
      placement: {
        title: 'Staðsetning',
        loading: 'Talning í gangi…',
        loadError: 'Staðsetningartalningin svaraði ekki — reyndu aftur síðar.',
        draftHint: 'Talningin er reiknuð út frá yfirlýstu nettengingunni: hún birtist um leið og þjónustan er til. Stofnun er hafnað þegar enginn meðlimur getur þjónað henni, og höfnunin nefnir gangverkið sem tæmdi mengið.',
        eligibleCount: '{n} af {m} meðlimum geta þjónað þessari þjónustu',
        recommended: 'Mælt með',
        eligible: 'Gjaldgengur',
        notEligible: 'Ekki gjaldgengur',
        blockedReachability: 'netið nær ekki til þessa meðlims',
        blockedRequireTag: 'stöðvað af áskildu merki (requireNodes)',
        blockedExcluded: 'útilokaður í hermuninni',
        preferenceUnknown: 'er ekki (lengur) meðlimur í klasanum',
        preferenceIgnored: 'Óskin „{node}“ er ekki gjaldgeng í dag: {reason}. Ráðlegging talningarinnar ræður — aldrei villa, þjónustan býr annars staðar.',
        emptyReachability: 'Enginn meðlimur getur þjónað þessari þjónustu: netið nær hvergi — engin merkjabreyting mun hjálpa. Tengdu hnútinn með kapli, eða færðu þjónustuna þangað sem netið er.',
        emptyRequireTag: 'Enginn meðlimur getur þjónað þessari þjónustu: það voru áskildu merkin sem tæmdu mengið — fjarlægðu færsluna úr requireNodes, eða merktu meðlim.',
        spof: 'Einn bilunarpunktur',
        spofDetail: 'Aðeins einn meðlimur getur hýst þjónustuna: við bilun hefur failover hvergi að fara. Þjónusta með marga hlustara flyst sem EIN HEILD — hnúturinn sem tekur við verður að sjá ÖLL netin hennar: það er kostnaðurinn.',
        whatIf: 'Herma eftir fjarverandi meðlimum',
        whatIfHint: 'What-if tæmingarinnar: spurðu ÁÐUR en rýmt er, ekki uppgötva það við failover.',
        survives: 'Með {nodes} fjarverandi á þjónustan enn heimili.',
        notSurvives: 'Að rýma {nodes} skilur þessa þjónustu eftir NIÐRI: afleidda skilyrðið vinnur gegn aðgenginu (R30) — púki sem er á lífi þar sem netið nær ekki til þjónar engum og gerir engum viðvart.',
        transfer: 'Færa authority',
        transferError: 'Flutningurinn mistókst',
        transferTarget: 'Viðtökumeðlimur',
        transferHint: 'Aðeins gjaldgengir meðlimir eru í boði — ósk innan gilda mengisins, aldrei override. Ekkert verk: næsta umferð worker-anna ER leikurinn (gamli hnúturinn uppsker, sá nýi reisir).'
      }
    },
    fabric: {
      tabDerivation: 'Afleiðsla',
      importNetwork: 'Flytja inn úr öðru fabric',
      importTitle: 'Flytja inn rökrænt net',
      importHint: 'Innflutningurinn er skýr aðild: netið er áfram eigandans (sama auðkenni, sama stem, sama bridge tvf-<stem>) og héðan er það varpað á port/LAGG þessa fabric — að varpa ER að fullyrða að afhendingin endi í sama L2-léni og eigandans.',
      importPick: 'Net eigandans',
      importNone: 'Ekkert að flytja inn: hin fabric eiga ekkert eigið net sem þetta fabric þekkir ekki þegar',
      importedNetworksTitle: 'Innflutt net',
      noImported: 'Ekkert innflutt net',
      importedFrom: 'innflutt úr {fabric}',
      importedBy: 'Innflutt af: {list}',
      importedCount: '+{n} innflutt',
      owner: 'Eigandi',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Fjarlægja innflutning',
      unimportConfirm: 'Fjarlægja innflutning netsins {name} (eigandi {fabric}) úr þessu fabric? Hafnað á meðan port eða LAGG í þessu fabric varpar því, eða gestur, App eða þjónusta fær þjónustu aðeins um þennan fót.',
      unimportRefused: 'Innflutningur enn í notkun — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Þessi hnútur fær þetta net þegar úr öðru fabric sem hann er aðili að: hnútur tekur deilt net aðeins um EINN fót sinn (tveir uplink-ar á sama L2 í bridge án STP eru lykkja). Fjarlægðu vörpunina á portum eða LAGG annars fabric-anna.',
          otherFabricDerived: 'Skjalið ber blokk fabric sem hnúturinn lýsir ekki lengur kapli í átt að: beittu fyrst áætlun þess fabric (hún leggur til að fjarlægja tækin þess), eða taktu þau yfir með take-ownership ef fabric-ið er horfið.'
        },
        hint: 'O.3-afleiðsluáætlunin: fyrir hvern kaplaðan hnút staðan, diff afleitt-vs-núverandi, YFIRLÝST bond-grannfræðin, dual-stack flippin og skipulögðu synjanirnar/viðvaranirnar. Skrifvarið þar til SKÝRT apply — ekkert lendir nokkru sinni sjálfkrafa á hnút.',
        refresh: 'Endurhlaða áætlunina',
        empty: 'Enginn hnútur er kaplaður við þessa fabric (og enginn ber lengur blokk hennar).',
        refusal: 'Synjun',
        warning: 'Viðvörun',
        generation: 'skjalakynslóð {n}',
        state: {
          manual: 'Handvirkt',
          derived: 'Afleitt',
          diverged: 'Frávikið'
        },
        topologyTitle: 'Yfirlýst grannfræði',
        members: 'meðlimir',
        primary: 'aðal',
        held: 'haldið á EINUM meðlim',
        form: {
          perNetworkBond: 'Bond á hvert net',
          singleBond: 'Eitt fallback-bond',
          laggBond: 'LACP-bond (LAGG)',
          singlePort: 'Eitt tengi'
        },
        colAction: 'Aðgerð',
        colKind: 'Tegund',
        colDevice: 'Device',
        colDetail: 'Smáatriði',
        action: {
          add: 'bæta við',
          remove: 'fjarlægja',
          replace: 'skipta út'
        },
        diffEmpty: 'Enginn diff í bið — beitta skjalið passar við renderið.',
        diffBlocked: 'Enginn diff: synjanirnar að ofan loka á þennan hnút.',
        phasePlanned: 'áætlað (skref 1 af 3)',
        phaseDraining: 'að tæmast (skref 2 af 3)',
        probeUnobserved: 'Tæmingarnemi: aldrei tilkynnt — tómið er ÓÞEKKT (retire yrði synjað núna).',
        probeFailed: 'Tæmingarnemi: athugunin MISTÓKST — þekktu tímastimplarnir fylgja með, aldrei «tómt» sem enginn mældi.',
        probeActive: {
          one: 'Nemi: {n} virk tenging enn á gamla vistfanginu',
          other: 'Nemi: {n} virkar tengingar enn á gamla vistfanginu'
        },
        probeLastActive: 'síðasta virkni {time}',
        probeEmpty: {
          one: 'Nemi: tómt í {n} mínútu',
          other: 'Nemi: tómt í {n} mínútur'
        },
        probeEmptyUnknown: 'Nemi: tómt (síðan hvenær er óþekkt).',
        impact: '{nics} vNIC og {apps} App á þessum hnút nota þessi net: {list}',
        apply: 'Beita á þennan hnút',
        applyTitle: 'Beita afleiðslunni — {node}',
        applyIntro: 'Afleidda uppsetningin endurskrifar netskjal {node} ({n} breytingar) gegnum sömu dyr og host-network-ritillinn — NetworkManager-checkpoint og heiðarlegur nemi meðtalin. Viðvaranir áætlunarinnar hér að neðan fylgja með: lestu þær áður en þú staðfestir.',
        applyError: 'Apply mistókst',
        applyRefused: 'Hnúturinn synjaði:',
        planMoved: 'Fabric breyttist eftir þessa forskoðun — EKKERT var beitt. Áætlunin hefur verið endurhlaðin: skoðaðu aftur og reyndu á ný.',
        retire: 'Leggja niður',
        retireTitle: 'Óafturkræfur punktur — niðurlagning {address}',
        restore: 'Endurheimta',
        restoreTip: 'Aftur í skyndimyndina frá því fyrir apply (kynslóð {previous}) — afturköllun í einu skrefi (H13)',
        restoreTitle: 'Endurheimta fyrra skjal — {node}',
        restoreIntro: 'Netskjal {node} fer aftur í skyndimyndina sem tekin var fyrir síðasta apply (kynslóð {previous}), endurskrifuð sem kynslóð {next} í stað {current}. Workerinn samræmir það eins og hvert annað skjal.',
        restoreRedo: 'Skjalið sem var skipt út verður nýja skyndimyndin: að endurheimta aftur er redo.',
        restoreClosesChain: 'Skyndimyndin er handvirka skjalið frá því fyrir afleiðsluna: keðjan lokast hér — engin frekari afturköllun, hnúturinn er handvirkur til næsta apply.',
        restoreConfirm: 'Endurheimta',
        restoreError: 'Endurheimt mistókst',
        retireIntro: 'Þetta fjarlægir {address} ({network}) af {point} endanlega. Eftir þessa aðgerð er leiðin til baka ÖFUGT flipp — að endurlýsa gamla vistfanginu gegnum sömu vél — aldrei blind endurheimt.',
        retireOld: 'Gamalt vistfang (fjarlægt)',
        retireNew: 'Nýtt vistfang (verður áfram)',
        retireEmptyFact: 'Tæmingarneminn tilkynnir vistfangið tómt: þessi fjarlæging slítur engri athugaðri tengingu.',
        retireConfirm: 'Leggja vistfangið niður',
        severActiveLoss: {
          one: 'Slíta {n} virkri tengingu enn á gamla vistfanginu — hún deyr með þessari aðgerð',
          other: 'Slíta {n} virkum tengingum enn á gamla vistfanginu — þær deyja með þessari aðgerð'
        },
        severUnknownLoss: 'Samþykkja hið ÓÞEKKTA: neminn hefur aldrei athugað þetta vistfang (eða athugunin bregst) — lifandi tengingar geta slitnað.'
      },
      title: 'Fabric',
      createTitle: 'Búa til fabric',
      networks: 'Net',
      switches: 'Skiptar',
      ports: 'Port',
      laggs: 'LAGG',
      subnets: 'Undirnet',
      tabOverview: 'Yfirlit',
      tabNetworks: 'Rökræn net',
      tabSwitches: 'Skiptar',
      overviewHint: 'Fabric-ið í fljótu bragði: hvert röklegt net með MTU og undirneti (VLAN-in búa aðeins í vörpunum fyrir hvert port/LAGG — sama netið getur ferðast með ólíkum tags á ólíkum portum). Fabric-ið er skrá yfir YTRI innviði — TVirt athugar og lýsir yfir, sér aldrei um provisioning, og snertir aðeins NIC sem skráð eru undir stjórn þess.',
      absorptionHint: 'Hvert undirnet sem lýst er yfir hér LEIÐIR færslu sína í IPAM-skránni í sömu skrift — það lifir og deyr með netinu.',
      scopeFixedHint: 'Scope er fast við rót klasans: efnisleg innviðauppbygging nær samkvæmt skilgreiningu yfir allan klasann.',
      networksHint: 'Hvert net ber skyldubundna MTU (sjálfgefið 1500) og skyldubundið undirnet; gátt, DNS-þjónar og fastar leiðir sem lýst er yfir hér eru EINA UPPSPRETTAN fyrir NIC þjóna, öpp og netþjónustur.',
      switchesHint: 'Handvirka skráin: port er ónotað, varpað (untagged umferð og eftir VLAN-tag á rökrænu netin) eða meðlimur í LAGG — meðlimur ber engar eigin varpanir.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Skylda — IPAM leiðir sjálfkrafa af því færslu sína',
      nodeAddressing: 'Hnútavistfang',
      nodeAddressingNone: 'Ekkert — ekkert vistfang á hnút',
      nodeAddressingPool: 'Pool — eitt fast vistfang á hvern afgreiddan hnút',
      nodeAddressingHint: 'Með Pool úthlutar fabric-afleiðslan hverjum afgreiddum hnút vistfangi úr sviðunum sem frátekin eru fyrir TVirt (fast eftir úthlutun).',
      backing: 'Backing',
      gateway: 'Gátt',
      ranges: 'Frátekin bil',
      dns: 'DNS-þjónar (aðskildir með kommu)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gátt, DNS og leiðir sem lýst er yfir hér eru eina uppsprettan — NIC þjóna, öpp og netþjónustur sækja hingað',
      routesTitle: 'Fastar leiðir',
      routeDestination: 'Áfangastaður (CIDR)',
      routeVia: 'Um (next hop)',
      portUsed: 'Í notkun',
      vlanMappings: 'VLAN-varpanir',
      vlanTag: 'VLAN-tag',
      vlanNetwork: 'Röklegt net',
      nameTaken: 'Nafn þegar í notkun í fabric-inu',
      addNetwork: 'Bæta við neti',
      editNetwork: 'Breyta neti',
      deleteNetwork: 'Fjarlægja net',
      deleteNetworkConfirm: 'Fjarlægja röklega netið {name} úr fabric-inu? Leidda undirnetið þess í IPAM deyr með því (hafnað meðan þjónusta eða app notar það). Tengingar gátta og LAGG sem vísa á það eru hreinsaðar.',
      switchName: 'Skiptir',
      portName: 'Port',
      positionHint: 'Efnisleg staðsetning (valfrjálst) — sami orðaforði og staðsetning þjóna; aðeins yfirlýsing',
      addSwitch: 'Bæta við skipti',
      editSwitch: 'Breyta skipti',
      deleteSwitch: 'Fjarlægja skipti',
      deleteSwitchConfirm: 'Fjarlægja skiptinn {name} með öllum portum hans? LAGG-in dragast saman í samræmi við það (og deyja undir tveimur portum).',
      addPort: 'Bæta við porti',
      editPort: 'Breyta porti',
      deletePort: 'Fjarlægja port',
      deletePortConfirm: 'Fjarlægja portið {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:net)',
      taggedShort: 'Tagged',
      portCabling: 'Lagnir',
      portState: 'Staða',
      stateUnused: 'ónotað',
      stateMapped: 'varpað',
      laggPortGuard: 'Porti sem er meðlimur í LAGG er breytt frá LAGG-hliðinni',
      laggsTitle: 'LAGG',
      laggsHint: 'LAGG er 2+ port í LACP og getur þverað skipta (MLAG, gagnsætt); aðeins ónotuð port komast inn, LAGG-ið er vörpunarflöturinn, fjarlægt port verður aftur ónotað.',
      addLagg: 'Bæta við LAGG',
      editLagg: 'Breyta LAGG',
      deleteLagg: 'Fjarlægja LAGG',
      deleteLaggConfirm: 'Fjarlægja LAGG-ið {name}? Meðlimaport þess verða aftur ónotuð.',
      lacpRate: 'LACP-hraði',
      laggPorts: 'Meðlimaport (2+)',
      laggPortsHint: 'Aðeins ónotuð port komast inn — losaðu fyrst varpað port',
      noNetworks: 'Ekkert röklegt net yfirlýst.',
      noSwitches: 'Enginn skiptir yfirlýstur.',
      noLaggs: 'Ekkert LAGG yfirlýst.',
      staleConflict: 'Annar stjórnandi breytti þessu fabric-i á meðan þú varst að breyta því: vistun var hafnað svo vinna hans þurrkist ekki út. Breytingarnar þínar eru enn hér, ósnertar. Uppfærða fabric-ið hefur þegar verið endurhlaðið: staðfestu aftur til að leggja þær ofan á, eða hættu við og skoðaðu hvað breyttist.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Aðeins leitt: hvert undirnet fæðist af röklegu fabric-neti eða overlay-neti — því er breytt við uppsprettuna. Úthlutuð vistföng sýna HVER heldur þeim; bil frátekin fyrir TVirt eru pool sjálfvirku úthlutunarinnar.',
      search: 'Leita eftir nafni, CIDR eða vistfangi',
      empty: 'Ekkert net — lýstu yfir röklegu fabric-neti eða overlay-undirneti: IPAM leiðist sjálfkrafa af þeim.',
      reserved: 'Bil frátekin fyrir TVirt',
      address: 'Vistfang',
      origin: 'Uppruni',
      origin_declared: 'yfirlýst',
      origin_observed: 'athugað',
      holder: 'Haldið af',
      noAddresses: 'Ekkert þekkt vistfang í þessu undirneti.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Breyta við uppsprettuna'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Eldveggshópar',
      createTitle: 'Nýr eldveggshópur',
      editTitle: 'Breyta eldveggshópi',
      empty: 'Engir eldveggshópar enn — búðu til einn: endurnýtanlegur orðaforði af reglum, sem guest-NIC vísa í eftir nafni.',
      nameHint: 'Bókstafir, tölustafir og innri . - _; einkvæmt innan síns scope (alnafnar annars staðar aðgreinast með /scope/nafn)',
      description: 'Lýsing',
      descriptionHint: 'Ein lína um ætlunina, sýnd alls staðar þar sem hópurinn er valinn',
      enforced: 'Framfylgt á scope-inu',
      enforcedHint: 'Slökkt: hreinn orðaforði — reglurnar binda aðeins þau NIC sem vísa í hópinn. Kveikt: reglurnar binda hvert guest-NIC með kveiktan eldvegg undir scope hópsins, hvort sem vísað er í hann eða ekki.',
      enforcedChip: 'Framfylgt',
      enforcedChipHint: 'Reglurnar binda hvert guest-NIC með kveiktan eldvegg undir scope hópsins, hvort sem vísað er í hann eða ekki',
      enforceWarning: 'Sé framfylgdin virkjuð binda reglurnar HVERT guest-NIC með kveiktan eldvegg undir {scope} við næstu samleitni, einnig án beinnar tilvísunar — og innan virkrar chain er drop forföður endanlegt: stigin fyrir neðan opna það ekki aftur.',
      unenforceInfo: 'Sé framfylgdin tekin af sitja reglurnar aðeins eftir á þeim NIC sem vísa beint í hópinn.',
      rules: 'Reglur',
      tabOverview: 'Yfirlit',
      tabRules: 'Reglur',
      orderHint: 'Röð raðanna ER matsröðin innan hópsins: fyrsta reglan sem passar vinnur.',
      statefulHint: 'Stateful er innifalið: svör við leyfðri umferð fara sjálfkrafa í gegn (established/related samþykkt, invalid hent — vélin skýtur þessu inn, það er aldrei skrifað í höndunum).',
      noRules: 'Engar reglur — orðaforði í smíðum: að vísa í hann er leyfilegt og skilar engu.',
      addRule: 'Bæta við reglu',
      direction: 'Stefna',
      directionIn: 'Inn',
      directionOut: 'Út',
      action: 'Aðgerð',
      action_accept: 'Samþykkja',
      action_drop: 'Henda',
      action_reject: 'Hafna',
      protocol: 'Samskiptaregla',
      protocolAny: 'Hver sem er',
      ports: 'Port',
      source: 'Uppruni',
      dest: 'Áfangastaður',
      comment: 'Athugasemd',
      addressHint: 'IPv4-CIDR eða <fabric>/<röklegt net>; tómt = hvað sem er',
      moveUp: 'Færa upp',
      moveDown: 'Færa niður',
      nicFirewall: 'Eldveggur',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Eldveggshópar',
      nicGroupsPlaceholder: 'Veldu hóp…',
      nicGroupsHint: 'Sýnilegu hóparnir, að meðtöldum þeim frá æðri scope (nothæfir niður á við, eins og merki)',
      nicGroupCount: { one: '{n} eldveggshópur', other: '{n} eldveggshópar' },
      nicOff: 'Slökkt á eldvegg',
      pendingRestartHint: 'Eldveggsbreytingar fylgja líkaninu vistað/beitt: þær bíða næsta power cycle (PendingRestart). Hópar sem æðri scope framfylgja gilda þegar kveikt er á eldvegg NIC-sins.',
      appConvergeHint: 'Eldveggsbreytingar taka gildi við næstu samleitni gámsins. Hópar sem æðri scope framfylgja gilda þegar kveikt er á eldveggnum.',
      enforcedAncestors: 'Framfylgt af æðri scope',
      enforcedAncestorsHint: 'Þessi hópur gildir um hvert NIC undir sínu scope þar sem KVEIKT er á eldveggnum — rofinn er aðalrofi NIC-sins (slökkt = alls engin chain, forfeður meðtaldir); innan virkrar chain er vald forföðurins endanlegt: hans drop verður ekki opnað aftur fyrir neðan.'
    }
  }
}
